// extracted by mini-css-extract-plugin
export var currencyInput = "_jv-1";
export var currencySymbol = "_jv-0";